import {FC} from 'react'
import {User} from '../../core/_models'
import {phoneMask} from '../../../../../utils/phoneMask'

type Props = {
  user: User
}

const PhoneCell: FC<Props> = ({user}) => (
  <span className='text-gray-800'>{user.phone ? phoneMask(user.phone) : '-'}</span>
)

export {PhoneCell}
